// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HYFoR","text":"styles_text__TZszP","decorationLeft":"styles_decorationLeft__Bkh5d","decorationRight":"styles_decorationRight__bqtmQ"};